<template>
  <section>
    <v-dialog v-model="dialog" :max-width="maxwidthpopup">
      <v-card>
        <v-card-actions class="primary">
            <span style="color: white;" class="text-h6">Verification Policy</span>
        </v-card-actions>

          <!-- <div v-html="surety.surety_remarks"></div> -->
        <v-card-text class="mt-5 d-flex align-center">
          <v-icon :color="iconcolor" class="mx-auto text-h1">{{ icon }}</v-icon>
        </v-card-text>
        <v-card-text class="d-flex align-center">
          <span class="text-center d-block mx-auto" style="font-size:13px;color:black;" v-html="text"></span>
        </v-card-text>



        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    type: "", 
    search: "",
    loading: false,
    icon: "",
    iconcolor :"",
    text:"",
    maxwidthpopup: "",
    textclass: "",
    surety: {
      surety_fastflowrow: "",
      surety_policyno: "",
      surety_certificateno: "",
      surety_inception: "",
      surety_expiry: "",
      surety_principalname: "",
      surety_tsi: "",
      surety_remarks: "",
      surety_ticketid: "",
    },
    fastflow: {
      fastflow_ano: "",
      fastflow_policyno: "",
      fastflow_certificateno: "",
      fastflow_inception: "",
      fastflow_expiry: "",
      fastflow_remarks: "",
    },

  }),
  methods: {
    FormatDate(value) {
      if (!value) return "-";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";

      return date.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    FormatCurrency(value) {
      const amount = Number(value);
      if (Number.isNaN(amount)) return "-";

      return amount.toLocaleString("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    EscapeHtml(value) {
      return String(value || "-")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    BuildSuretyText() {
      const certificateNo =
        this.surety.surety_ticketid || this.surety.surety_policyno || "-";
      const period = `${this.FormatDate(this.surety.surety_inception)} s/d ${this.FormatDate(this.surety.surety_expiry)}`;

      return `
        <div style="text-align:left;line-height:1.8;">
          <table style="width:100%;border-collapse:collapse;table-layout:fixed;">
            <tbody>
              <tr>
                <td style="width:35%;padding:4px 8px 4px 0;font-weight:bold;vertical-align:top;">Nomor jaminan</td>
                <td style="width:4%;padding:4px 6px;vertical-align:top;">:</td>
                <td style="padding:4px 0;vertical-align:top;word-break:break-word;">${this.EscapeHtml(certificateNo)}</td>
              </tr>
              <tr>
                <td style="width:35%;padding:4px 8px 4px 0;font-weight:bold;vertical-align:top;">Nama Principal</td>
                <td style="width:4%;padding:4px 6px;vertical-align:top;">:</td>
                <td style="padding:4px 0;vertical-align:top;word-break:break-word;">${this.EscapeHtml(this.surety.surety_principalname)}</td>
              </tr>
              <tr>
                <td style="width:35%;padding:4px 8px 4px 0;font-weight:bold;vertical-align:top;">Nilai Jaminan</td>
                <td style="width:4%;padding:4px 6px;vertical-align:top;">:</td>
                <td style="padding:4px 0;vertical-align:top;word-break:break-word;">${this.EscapeHtml(this.FormatCurrency(this.surety.surety_tsi))}</td>
              </tr>
              <tr>
                <td style="width:35%;padding:4px 8px 4px 0;font-weight:bold;vertical-align:top;">Periode</td>
                <td style="width:4%;padding:4px 6px;vertical-align:top;">:</td>
                <td style="padding:4px 0;vertical-align:top;word-break:break-word;">${this.EscapeHtml(period)}</td>
              </tr>
            </tbody>
          </table>
          <br>
          <div style="text-align:center;margin-bottom:12px;">
            Sertifikat terjamin benar dan teregister dalam Sistem kami dan sebagai dokumen yang Sah
          </div>
        </div>
      `;
    },
    ListSurety(params) {
      this.loading = true;
      const formData = new FormData();
      formData.append("surety_fastflowrow", params);
      // let param = this.$functions.ParamPOST(formdata);
      this.$axios.post(this.$functions.SafeURL('apiListFastflowSuretyGuarantee'),formData,{
        headers: {
          'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
      })
      .then(response => {
        let feedback = response.data;
        if (feedback.length > 0) {
          if (feedback[0].feedback === "Y") {
            this.dialog = true;
            this.icon = "mdi-check-circle"
            this.iconcolor = "green dark-3"
            this.surety.surety_fastflowrow = feedback[0].surety_fastflowrow;
            this.surety.surety_policyno = feedback[0].surety_policyno;
            this.surety.surety_certificateno = feedback[0].surety_certificateno;
            this.surety.surety_inception = feedback[0].surety_inception;
            this.surety.surety_expiry = feedback[0].surety_expiry;
            this.surety.surety_principalname = feedback[0].surety_principalname;
            this.surety.surety_tsi = feedback[0].surety_tsi;
            this.surety.surety_ticketid = feedback[0].surety_ticketid;
            this.text = this.BuildSuretyText();
            this.maxwidthpopup = "700px"
          } else {
            this.dialog = true;
            this.icon = "mdi-close-circle";
            this.iconcolor = "red dark-3";
            this.text = "<strong>DATA TIDAK VALID</strong>";
            this.maxwidthpopup = "600px"
          }
        } else {
          this.dialog = true;
          this.icon = "mdi-close-circle";
          this.iconcolor = "red dark-3";
          this.text = "<strong>DATA TIDAK VALID</strong>";
          this.maxwidthpopup = "600px"
        }
      })
      .catch(e => {
        alert(e);
          this.dialog = true;
          this.icon = "mdi-close-circle";
          this.iconcolor = "red dark-3";
          this.surety.surety_remarks = "Terjadi ";
          this.maxwidthpopup = "600px"
      });
    },
    ListPolicy(params) {
      this.loading = true;
      const formData = new FormData();
      formData.append("fastflow_policyno", params);
      // let param = this.$functions.ParamPOST(formdata);
      this.$axios.post(this.$functions.SafeURL('apiCheckPolicyFastflow'),formData,{
        headers: {
          'Content-Type': 'text/plain; charset=ISO-8859-1'
        }
      })
      .then(response => {
        let feedback = response.data;
        if (feedback.length > 0) {
          if (feedback[0].feedback === "Y") {
            this.dialog = true;
            this.icon = "mdi-check-circle"
            this.iconcolor = "green dark-3"
            this.fastflow.fastflow_refid = feedback[0].fastflow_refid;
            this.fastflow.fastflow_policyno = feedback[0].fastflow_policyno;
            this.text = "POLIS DENGAN  NOMOR <strong> "+ this.fastflow.fastflow_policyno + "</strong> VALID "
            this.maxwidthpopup = "700px"
          } else {
            this.dialog = true;
            this.icon = "mdi-close-circle";
            this.iconcolor = "red dark-3";
            this.text = "<strong>DATA TIDAK VALID</strong>";
            this.maxwidthpopup = "600px"
          }
        } else {
          this.dialog = true;
          this.icon = "mdi-close-circle";
          this.iconcolor = "red dark-3";
          this.text = "<strong>DATA TIDAK VALID</strong>";
          this.maxwidthpopup = "600px"
        }
      })
      .catch(e => {
        alert(e);
          this.dialog = true;
          this.icon = "mdi-close-circle";
          this.iconcolor = "red dark-3";
          this.fastflow.fastflow_remarks = "Terjadi ";
          this.maxwidthpopup = "600px"
      });
    },
  },
  mounted() {
    const params = this.$route.params.params;
    const type = this.$route.params.type;
    console.log(params)
    console.log(type)
    if (type == 'surety' ) {
      this.ListSurety(params);
    } else {
      this.ListPolicy(params);
    }
  }
};
</script>
